import ExpandText from './ExpandText.component';
export default ExpandText;